import { Box, SkeletonRectangle } from '@wix/design-system';
import React from 'react';
import { ProductCardFeaturesSkeleton } from './ProductCardFeaturesSkeleton';

interface ProductCardSkeletonProps {
  cardIndex: number;
}

export const ProductCardSkeleton = ({
  cardIndex,
}: ProductCardSkeletonProps) => {
  return (
    <Box
      direction="vertical"
      gap="SP2"
      align="center"
      padding="SP3"
      dataHook={`product-card-skeleton-${cardIndex}`}
      border="1px solid #E0E0E0"
      borderRadius="6px"
    >
      <SkeletonRectangle
        height="20px"
        width="100px"
        dataHook={`card-title-skeleton-${cardIndex}`}
      />
      <SkeletonRectangle
        height="12px"
        width="140px"
        dataHook={`card-description-skeleton-${cardIndex}`}
      />
      <SkeletonRectangle
        height="40px"
        width="90px"
        dataHook={`card-price-skeleton-${cardIndex}`}
      />
      <SkeletonRectangle
        height="30px"
        width="160px"
        dataHook={`card-button-skeleton-${cardIndex}`}
      />
      <ProductCardFeaturesSkeleton cardIndex={cardIndex} />
    </Box>
  );
};
